import styled from "styled-components";
import Button from "@material-ui/core/Button/Button";
import {Edit, CloudDownload} from "@material-ui/icons";

export const CloudDownloadIcon = styled(CloudDownload)`
    margin-left: 8px;
`;

export const EditIcon = styled(Edit)`
    margin-left: 8px;
`;

export const ActionButton = styled(Button)`
    && {
        min-width: 150px;
        margin: 4px 8px;
    }
`;

export const ButtonWrapper = styled.div`
    padding: 4px;
`;



// WEBPACK FOOTER //
// ./src/common/ActionButtons/ActionButtons.sc.js